import { render } from "./MHome.vue?vue&type=template&id=3ff9f60c&scoped=true"
import script from "./MHome.vue?vue&type=script&lang=js"
export * from "./MHome.vue?vue&type=script&lang=js"

import "./MHome.vue?vue&type=style&index=0&id=3ff9f60c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff9f60c"]])

export default __exports__